.campo {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.etiqueta {
  font-size: var(--text-body);
  font-weight: 500;
  color: var(--text-2);
}

.requerido {
  color: var(--status-danger);
  margin-left: 2px;
}

.envoltorio {
  position: relative;
  display: flex;
  align-items: center;
}

.entrada {
  width: 100%;
  background: var(--input-fondo);
  border: 1px solid var(--input-borde);
  border-radius: var(--radius-input);
  padding: var(--input-padding);
  color: var(--input-texto);
  font-size: var(--text-body);
  line-height: 1.25rem;
  transition: all var(--transition-base);
}

@media (pointer: coarse) {
  .entrada {
    min-height: var(--touch-target);
    /* 16px evita que los navegadores móviles hagan zoom al enfocar. */
    font-size: 16px;
  }
}

.entrada::placeholder {
  color: var(--text-3);
}

.entrada:hover:not(:disabled) {
  border-color: var(--border-strong);
}

.entrada:focus {
  outline: none;
  border-color: var(--input-borde-foco);
  box-shadow: var(--focus-ring);
}

.entrada:disabled {
  background: var(--input-fondo-inactivo);
  color: var(--text-3);
  cursor: not-allowed;
}

.conIconoIzq {
  padding-left: 2.375rem;
}

.conIconoDer {
  padding-right: 2.6rem;
}

.iconoIzq,
.iconoDer {
  position: absolute;
  display: flex;
  align-items: center;
  color: var(--text-3);
  pointer-events: none;
}

.iconoIzq {
  left: 11px;
}

.iconoDer {
  right: 8px;
}

/* Botón dentro del campo (por ejemplo, mostrar contraseña). */
.accion {
  position: absolute;
  right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  min-height: 36px;
  background: none;
  border: none;
  border-radius: 8px;
  color: var(--text-3);
  cursor: pointer;
}

.accion:hover {
  color: var(--text-1);
  background: color-mix(in srgb, var(--text-2) 10%, transparent);
}

.conError .entrada {
  border-color: var(--status-danger);
}

.ayuda {
  font-size: var(--text-caption);
  color: var(--text-3);
}

.error {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: var(--text-caption);
  color: var(--status-danger);
  font-weight: 600;
}

/* --- Select --- */
.select {
  appearance: none;
  cursor: pointer;
  padding-right: 34px;
  background-image:
    linear-gradient(45deg, transparent 50%, currentColor 50%),
    linear-gradient(135deg, currentColor 50%, transparent 50%);
  background-position:
    calc(100% - 17px) calc(50% + 2px),
    calc(100% - 12px) calc(50% + 2px);
  background-size:
    5px 5px,
    5px 5px;
  background-repeat: no-repeat;
}

.select:disabled {
  cursor: not-allowed;
}
